export const LOGOS = {
  ICON: 'assets/images/ps-logo-icon.svg',
  DARK: 'assets/images/ps-logo-dark.svg',
  WHITE: 'assets/images/ps-logo-white.svg',
};
